import { render, staticRenderFns } from "./BookmarkMenuSm.vue?vue&type=template&id=3f483c00&scoped=true"
import script from "./BookmarkMenuSm.vue?vue&type=script&lang=js"
export * from "./BookmarkMenuSm.vue?vue&type=script&lang=js"
import style0 from "./BookmarkMenuSm.vue?vue&type=style&index=0&id=3f483c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f483c00",
  null
  
)

export default component.exports